const ADJECTIVES = [
	'Naturally', 'spotted',
	'New',
	'Delicious', 'Winged', 'checkered',
	'Ablaze', 'Abrupt', 'Accomplished', 'Active', 'Adored', 'Adulated', 'Adventurous', 'Affectionate', 'Amused', 'Amusing', 'Animal', 'Antique', 'Appreciated', 'Archaic', 'Ardent', 'Arrogant', 'Astonished', 'Audacious', 'Authoritative', 'Awestruck', 'Beaming', 'Bewildered', 'Bewitching', 'Blissful', 'Boisterous', 'Booming', 'Bouncy', 'Breathtaking', 'Bright', 'Brilliant', 'Bubbling', 'Calm', 'Calming', 'Capricious', 'Celestial', 'Charming', 'Cheerful', 'Cherished', 'Chiaroscuro', 'Chilled', 'Comical', 'Commanding', 'Companionable', 'Confident', 'Contentment', 'Courage', 'Crazy', 'Creepy', 'Dancing', 'Dazzling', 'Delicate', 'Delightful', 'Demented', 'Desirable', 'Determined', 'Devoted', 'Dominant', 'Dramatic', 'Drawn out', 'Dripping', 'Dumbstruck', 'Ebullient', 'Elated', 'Elegant', 'Enchanted', 'Energetic', 'Enthusiastic', 'Ethereal', 'Exaggerated', 'Exalted', 'Expectant', 'Expressive', 'Exuberant', 'Faint', 'Fantastical', 'Favorable', 'Febrile', 'Feral', 'Feverish', 'Fiery', 'Floating', 'Flying', 'Folksy', 'Fond', 'Forgiven', 'Forgiving', "Freakin' awesome", 'Frenetic', 'Frenzied', 'Friendly', 'amorous', 'Frosted', 'Funny', 'Furry', 'Galloping', 'Gaping', 'Gentle', 'Giddy', 'Glacial', 'Gladness', 'Gleaming', 'Gleeful', 'Gorgeous', 'Graceful', 'Grateful', 'Halting', 'Happy', 'Haunting', 'Heavenly', 'Hidden', 'spirited', 'Honor', 'Hopeful', 'Hopping', 'Humble', 'Hushed', 'Hypnotic', 'Illuminated', 'Immense', 'Imperious', 'Impudent', 'Charged', 'Inflated', 'Innocent', 'Inspired', 'Intimate', 'Intrepid', 'Jagged', 'Joking', 'Joyful', 'Jubilant', 'Kindly', 'Languid', 'Larger than life', 'Laughable', 'Lickety', 'Lighthearted', 'Limping', 'Linear', 'Lively', 'Lofty', 'Loved', 'Lovely', 'Lulling', 'Luminescent', 'Lush', 'Luxurious', 'Magical', 'Maniacal', 'Manliness', 'March', 'Masterful', 'Merciful', 'Merry', 'Mischievous', 'Misty', 'Modest', 'Moonlit', 'Mysterious', 'Mystical', 'Mythological', 'Nebulous', 'Nostalgic', 'On fire', 'Overstated', 'Paganish', 'Partying', 'Perfunctory', 'Perky', 'Perplexed', 'Persevering', 'Pious', 'Playful', 'Pleasurable', 'Poignant', 'Portentous', 'Posh', 'Powerful', 'Pretty', 'Prickly', 'Prideful', 'Princesslike', 'Proud', 'Puzzled', 'Queenly', 'Questing', 'Quiet', 'Racy', 'Ragged', 'Regal', 'Rejoicing', 'Relaxed', 'Reminiscent', 'Repentant', 'Reserved', 'Resolute', 'Ridiculous', 'Ritualistic', 'Robust', 'Running', 'Sarcastic', 'Scampering', 'Scoffing', 'Scurrying', 'Sensitive', 'Serene', 'Shaking', 'Shining', 'Silky', 'Silly', 'Simple', 'Singing', 'Skipping', 'Smooth', 'Sneaky', 'Soaring', 'Sophisticated', 'Sparkling', 'Spell', 'Spherical', 'Spidery', 'Splashing', 'Splendid', 'Spooky', 'Sprinting', 'Starlit', 'Starry', 'Startling', 'Successful', 'Summery', 'Surprised', 'Sympathetic', 'Tapping', 'Teasing', 'Tender', 'Thoughtful', 'Thrilling', 'Tingling', 'Tinkling', 'Totemic', 'Touching', 'Tranquil', 'Treasured', 'Trembling', 'Triumphant', 'Twinkling', 'Undulating', 'Unruly', 'Urgent', 'Veiled', 'Velvety', 'Victorious', 'Vigorous', 'Virile', 'Walking', 'Wild', 'Witty', 'Wondering', 'Zealous', 'Zestful' ];

const NOUNS = [
	'American',
	'yellow',
	'warbler',
	'Yellow',
	'Common',
	'yellowthroat',
	'Hooded',
	'Prothonotary',
	'Cerulean',
	'Blackburnian',
	'redstart',
	'Wilson',
	'Kirtland',
	'Black-and-white',
	'Magnolia',
	'Blackpoll',
	'Palm',
	'Chestnut',
	'Pine',
	'Golden',
	'Blue',
	'Ovenbird',
	'Black',
	'blue',
	'green',
	'Nashville',
	'Cape',
	'May',
	'Canada',
	'Bay',
	'Worm',
	'Prairie',
	'Kentucky',
	'Yellow',
	'Northern',
	'parula',
	'Townsend',
	'Tennessee',
	'Orange-crowned',
	'Louisiana',
	'waterthrush',
	'Connecticut',
	'Hermit',
	'gray',
	'Mourning',
	'Golden',
	'Swainson',
	'MacGillivray',
	'Wood',
	'Lucy',
	'Damask',
	'rose',
	'China',
	'Multiflora',
	'Mr.',
	'Lincoln',
	'Beach',
	'Rosa',
	'Peace',
	'Corymb',
	'French',
	'White',
	'of',
	'york',
	'Double',
	'Guinea',
	'Ireland',
	'Borneo',
	'Majorca',
	'Vancouver',
	'Island',
	'O‘ahu',
	'Long',
	'Hispaniola',
	'Crete',
	'Te',
	'Waipounamu',
	'South',
	'Cape',
	'Breton',
	'Hawaiian',
	'Islands',
	'Honshu',
	'Sulawesi',
	'Ika-a-Māui',
	'North',
	'Mindanao',
	'Luzon',
	'Bioko',
	'Bali',
	'Kyushu',
	'Guadalcanal',
	'Tenerife',
	'Gran',
	'Canaria',
	'Maui',
	'Malaita',
	'Baffin',
	'Rhodes',
	'Shikoku',
	'Sumatra',
	'Okinawa',
	'Bora',
	'Saint',
	'Martin',
	'Kauai',
	'Upolu',
	'Timor',
	'Ellesmere',
	'Viti',
	'Levu',
	'Euboea',
	'Espiritu',
	'Santo',
	'Sakhalin',
	'Ascension',
	"Hawai'i",
	'Bougainville',
	'Grand',
	'Bahama',
	'San',
	'Cristobal',
	'Victoria',
	'Fuerteventura',
	'Newfoundland',
	'Java',
	'Tahiti',
	'Delight',
	'KORbin',
	'Memorial',
	'Cabbage',
	'Lady',
	'Banks',
	'Austrian',
	'briar',
	'Dog',
	'Common',
	'Purslane',
	'Ausmas',
	'Bourbon',
	'Rose',
	'moschata',
	'Moss',
	'purslane',
	'Sweet-Brier',
	'glauca',
	'Burnet',
	'laevigata',
	'heleniae',
	'Manchu',
	'villosa',
	'majalis',
	'Glaucous',
	'dog',
	'Carolina',
	'Swamp',
	'Prickly',
	'wild',
	'Field',
	'Pink',
	'Evergreen',
	'Woods',
	'Nootka',
	'moyesii',
	'Alpine',
	'Robusta',
	'Liberica',
	'Excelsa',
	'Arabica',
	'Parsley',
	'Mint',
	'Dill',
	'Basil',
	'Sage',
	'Rosemary',
	'Thyme',
	'Cilantro',
	'Coriander',
	'Fennel',
	'Chamomile',
	'Tarragon',
	'Lavender',
	'Chives',
	'Bay',
	'Leaves',
	'Culantro',
	'Chervil',
	'Winter',
	'Savory',
	'Peppermint',
	'Stevia',
	'Lemongrass',
	'Oregano',
	'Marjoram',
	'Lemon',
	'Balm',
	'Aloe',
	'Myrtle',
	'Verbena',
	'Aloe',
	'vera',
	'Candelabra',
	'aloe',
	'Cape',
	'Tiger',
	'tooth',
	'Hedgehog',
	'Soap',
	'Short',
	'viridiflora',
	'Mountain',
	'Spiral',
	'Aloiampelos',
	'striatula',
	'Coral',
	'perryi',
	'succotrina',
	'ruspoliana',
	'harlana',
	'Snake',
	'massawana',
	'squarrosa',
	'peglerae',
	'erinacea',
	'jucunda',
	'vaombe',
	'rauhii',
	'camperi',
	'ballyi',
	'cryptopoda',
	'corallina',
	'comosa',
	'suzannae',
	'excelsa',
	'helenae',
	'hereroensis',
	'sinkatana',
	'khamiesensis',
	'reynoldsii',
	'nyeriensis',
	'scobinifolia',
	'forbesii',
	'ammophila',
	'dewinteri',
	'ballii',
	'vacillans',
	'jawiyon',
	'christianii',
	'inermis',
	'argenticauda',
	'Mitriformes',
	'Cicely',
	'Spearmint',
	'Wingpod',
	'Virginia',
	'Shining',
	'Smooth',
	'persica',
	'California',
	'Wild',
	'Climbing',
	'Tea',
	'Hybrid',
	'Rugosa',
	'Prairie',
	'Portulaca',
	'molokiniensis',
	'Virginia',
	'Painted',
	'Grace',
	'Red',
	'Yellow',
	'chat',
	'Olive',
	'Eurasian',
	'reed',
	'Scarlet',
	'tanager',
	'Summer',
	'Western',
	'Hepatic',
	'Flame',
	'Blue-gray',
	'Black-and-yellow',
	'Paradise',
	'Swallow',
	'Orange',
	'Magpie',
	'Hooded',
	'mountain',
	'White-capped',
	'Grass-green',
	'Grey',
	'Green',
	'Variable',
	'seedeater',
	'Shrike',
	'Short',
	'honeycreeper',
	'White',
	'shrike',
	'Rosy',
	'thrush',
	'Purple',
	'Bananaquit',
	'Multicoloured',
	'Seven',
	'Brazilian',
	'Brown',
	'White',
	'Scarlet',
	'Silver',
	'Common',
	'bush',
	'Plushcap',
	'Rufous',
	'Glistening-green',
	'Fawn',
	'Mourning',
	'sierra',
	'finch',
	'Blue',
	'winged',
	'White',
	'Blue',
	'Crimson',
	'Olive-green',
	'hooded',
	'Grey',
	'Palm',
	'Black',
	'Orange',
	'Pardusco',
	'Blue-black',
	'grassquit',
	'Masked',
	'crimson',
	'Yellow',
	'White',
	'Golden',
	'Bald',
	'eagle',
	'Golden',
	'Peregrine',
	'falcon',
	'Sandhill',
	'crane',
	'Osprey',
	'Common',
	'raven',
	'American',
	'robin',
	'Northern',
	'cardinal',
	'Canada',
	'goose',
	'Mourning',
	'dove',
	'House',
	'finch',
	'starling',
	'sparrow',
	'Goldfinch',
	'Mallard',
	'Blue',
	'jay',
	'pintail',
	'wigeon',
	'Dark',
	'junco',
	'Downy',
	'woodpecker',
	'Great',
	'horned',
	'owl',
	'blue',
	'heron',
	'kestrel',
	'Blue',
	'teal',
	'Piping',
	'plover',
	'Wood',
	'duck',
	'Hairy',
	'Black-capped',
	'chickadee',
	'Caspian',
	'tern',
	'Baltimore',
	'oriole',
	'Lesser',
	'scaup',
	'Bufflehead',
	'Greater',
	'Trumpeter',
	'swan',
	'shoveler',
	'Ring',
	'Red',
	'hawk',
	'Evening',
	'grosbeak',
	'black',
	'Red',
	'blackbird',
	'woodcock',
	'White',
	'Barn',
	'swallow',
	'Wild',
	'turkey',
	'Brown',
	'cowbird',
	'Eastern',
	'bluebird',
	'flicker',
	'loon',
	'Gadwall',
	'white-fronted',
	'Monarch',
	'butterfly',
	'Painted',
	'lady',
	'Cabbage',
	'white',
	'Red',
	'admiral',
	'Gulf',
	'fritillary',
	'Eastern',
	'tiger',
	'swallowtail',
	'Mourning',
	'cloak',
	'Viceroy',
	'Black',
	'Common',
	'buckeye',
	'Cloudless',
	'sulphur',
	'Giant',
	'Swallowtail',
	'Great',
	'spangled',
	'Pipevine',

	'Spicebush',
	'American',
	'Gray',
	'hairstreak',
	'Orange',
	'Zebra',
	'Small',
	'copper',
	'wood',
	'nymph',
	'Domestic',
	'silk',
	'moth',
	'Aphrodite',
	'Apollo',
	'Ares',
	'Artemis',
	'Athena',
	'Demeter',
	'Dionysus',
	'Hades',
	'Pluto',
	'Hephaestus',
	'Hera',
	'Hermes',
	'Hestia',
	'Poseidon',
	'Zeus',
	'Limenitis',
	'arthemis',
	'Butterfly',
	'weed',
	'blue',
	'tailed',
	'Clouded',
	'comma',
	'Variegated',
	'Edith',
	'checkerspot',
	'Pearl',
	'crescent',
	'milkweed',
	'Silver',
	'skipper',
	'Silvery',
	'blue',
	'Longwing',
	'Large',
	'heath',
	'Zerene',
	'Spring',
	'azure',
	'Question',
	'mark',
	'Baltimore',
	'Essex',
	'Swamp',
	'Boisduval',
	'Dreamy',
	'duskywing',
	'Tawny',
	'emperor',
	'Laurel',
	'pearl-bordered',
	'Green-veined',
	'Gypsy',
	'Moth',
	'Banded',
	'Melissa',
	'Sulphur',
	'Nostalgia',
	'Crocodile',
	'Aniseed',
	'Clover',
	'Urchin',
	'Strawberry',
	'Unicorn',
	'TropicBird',
	'frantic',
	'YellowRattle',
	'fishy',
	'tragic',
	'residence',
	'McGovernism',
	'wheelwrights',
	'PotHelmet',
	'torridness',
	'sarau',
	'mutism',
	'hogans',
	'shrublet',
	'libertines',
	'House',
	'bacons',
	'pasterns',
	'kutum',
	'luger',
	'wingnut',
	'screw',
	'tank',
	'steamer',
	'BenchScrew',
	'advancing',
	'addressability',
	'Tamashek',
	'tibicen',
	'pawnbroking',
	'TankSteamer',
	'gelidity',
	'premier',
	'bookshelves',
	'seiner',
	'gametocytes',
	'hair-raiser',
	'fairways',
	'Gielgud',
	'springbuck',
	'Walesa',
	'numerology',
	'J-pop',
	'swallowtails',
	'field',
	'fallow',
	'reclination',
	'parturience',
	'drudge',
	'sheikdom',
	'poker',
	'staithe',
	'viciosity',
	'challah',
	'ochlocracies',
	'thumbkin',
	'trichome',
	'usualness',
	'atelocollagen',
	'snake',
	'lizard',
	'redistillation',
	'designs',
	'guardant',
	'craniopagus',
	'txtspk',
	'chymistry',
	'rheotomes',
	'formene',
	'journeyman',
	'cow',
	'killer',
	'permanency',
	'Barthelme',
	'tortoise',
	'shell',
	'conpersons',
	'Hudson River',
	'leaven',
	'sennit',
	'vinasse',
	'bucky',
	'monger',
	'species',
	'station',
	'deathblows',
	'zingers',
	'arrondissement',
	'steroids',
	'tuyere',
	'tusks',
	'discussion',
	'derrière',
	'speed',
	'squaloids',
	'slapdash',
	'buckthorn',
	'infotainment',
	'annexes',
	'ursidae',
	'drypoints',
	'antithetic',
	'punto',
	'permissivity',
	'labrum',
	'geezer',
	'pellicularia',
	'beguinage',
	'consonant',
	'compositing',
	'fifties',
	'selectwoman',
	'shroud',
	'accouchement',
	'wastepaper',
	'marrot',
	'baddeleyite',
	'aidance',
	'testing',
	'mouflon',
	'Polynesians',
	'uninitiated',
	'nucleole',
	'halesia',
	'Descartes',
	'relentlessness',
	'calycle',
	'merit',
	'abreaction',
	'willing',
	'cocagne',
	'bitches',
	'yardman',
	'zymogen',
	'torchlight',
	'fashioning',
	'ephemera',
	'flutterer',
	'banjax',
	'acquaintedness',
	'ratting',
	'Esther',
	'decypher',
	'comfortlessness',
	'fourteen',
	'generatrix',
	'speaking',
	'provection',
	'hired',
	'demarch',
	'cajolery',
	'confects',
	'vaccinia',
	'rethor',
	'28',
	'quillon',
	'Baffin',
	'Island',
	'solidarité',
	'mandibulate',
	'wainscots',
	'adytum',
	'chati',
	'murex',
	'tracksuit',
	'favorability',
	'lament',
	'abluent',
	'dining',
	'mofussil',
	'william cowper',
	'records',
	'annamite',
	'distinguishment',
	'compeer',
	'jaundice',
	'nervus',
	'taker',
	'salaams',
	'cut',
	'Southdown',
	'trainbearer',
	'cultivator',
	'Skraeling',
	'fortunes',
	'major',
	'switches',
	'gecko',
	'trigonal',
	'Benedictus',
	'sentences',
	'coruscation',
	'organist',
	'conveyance',
	'thana',
	'misclaim',
	'wainscot',
	'saltern',
	'palkee',
	'anabiosis',
	'rotunda',
	'cetacean',
	'pearl',
	'catholicon',
	'sircar',
	'alimony',
	'empery',
	'russet',
	'nonlending',
	'wolverene',
	'reindeer',
	'unemployed',
	'turbine',
	'bragget',
	'subduedness',
	'vitelline',
	'nephridium',
	'convoy',
	'bulldust',
	'vulcano',
	'Judea',
	'zygapophysis',
	'troglodytes',
	'drugger',
	'daily',
	'trolly',
	'assegai',
	'cornetcy',
	'trophallaxis',
	'recreant',
	'Ellison',
	'Cameroun',
	'jabberwocky',
	'cornhole',
	'stocker',
	'familist',
	'renitence',
	'rheotaxis',
	'underlie',
	'virago',
	'hybridizer',
	'trifler',
	'obliviousness',
	'tow',
	'shears',
	'nappy',
	'polyphosphate',
	'immense',
	'ditty',
	'programme',
	'recoat',
	'pompholyx',
	'pneuma',
	'asperser',
	'phycis',
	'hydrocyanide',
	'octogenarian',
	'etesian',
	'distractor',
	'ineptitude',
	'milkshake',
	'visite',
	'leishmaniasis',
	'clomipramine',
	'breadstick',
	'pinole',
	'incivility',
	'parascenium',
	'broomstaff',
	'aichmophobia',
	'piggery',
	'Muscovian',
	'conjecturally',
	'fumage',
	'weasel',
	'sorts',
	'house',
	'customs',
	'hippopus',
	'jackdaw',
	'perversity',
	'premier',
	'Dutchman',
	'imperf',
	'jumpiness',
	'hook',
	'maomao',
	'unceasingly',
	'pickerel',
	'weed',
	'melodist',
	'Austria',
	'supawn',
	'zechin',
	'valerianella',
	'ladder',
	'scarabæus',
	'slime',
	'triplicate',
	'nattiness',
	'guy',
	'winter',
	'summer',
	'autumn',
	'spring',
	'fall',
	'Albion',
	'liquidity',
	'snail',
	'psychodynamics',
	'halothane',
	'trader',
	'gruff',
	'tidesman',
	'firestone',
	'prosoma',
	'goat'
];

const randomItem = ( arr ) => {
	const item = arr[ Math.floor( Math.random() * arr.length ) ];
	return item.slice( 0, 1 ).toUpperCase() + item.slice( 1 );
};

export default function name() {
	const seed = Math.random();
	if ( seed <= 0.25 ) {
		return `${ randomItem( ADJECTIVES ) }${ randomItem( NOUNS ) }`;
	} else if ( seed <= 0.5 ) {
		return `${ randomItem( NOUNS ) }${ randomItem( NOUNS ) }`;
	} else if ( seed <= 0.75 ) {
		return `${ randomItem( NOUNS ) }`;
	} else {
		return `${ randomItem( ADJECTIVES ) }`;
	}
}
